"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function CurrencyExchangeRateExpandableItem(_ref) {
  var sourceCurrencyId = _ref.sourceCurrencyId,
    currencyId = _ref.currencyId,
    value = _ref.value,
    currencies = _ref.currencies,
    last = _ref.last;
  var currency = (0, _react.useMemo)(function () {
    return currencies.find(function (el) {
      return el.id === currencyId;
    });
  }, [currencies, currencyId]);
  var currencyName = (0, _react.useMemo)(function () {
    if (currency) {
      return "".concat(currency.name, " (").concat(currency.id, ")");
    }
    return currencyId;
  }, [currency, currencyId]);
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    key: currencyId,
    justifyContent: "flex-end",
    sx: function sx(theme) {
      return {
        mb: last ? 0 : 1,
        py: 1,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100]
      };
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 9,
    md: 8,
    lg: 7,
    sx: {
      pl: 3
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2"
  }, currencyName)), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 3,
    md: 4,
    lg: 5,
    sx: {
      pr: 3
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    component: "h6",
    textAlign: "right",
    fontWeight: "bold"
  }, (0, _commons.formatCurrecy)({
    value: value,
    currencyId: sourceCurrencyId,
    maxDecimals: 7
  }))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(CurrencyExchangeRateExpandableItem);